import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8806d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock" }
const _hoisted_2 = { class: "stockcardparent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stocktitle" }, [
  /*#__PURE__*/_createElementVNode("a", null, "Skat")
], -1))

import Card from "@/model/Card";

import CardComponent from "./CardComponent.vue";
import { store } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'StockComponent',
  props: {
  cards: Array,
},
  setup(__props) {



const play = (card: Card) => {
  store.game.onStockCardSelect(card)
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card, index) => {
        return (_openBlock(), _createBlock(CardComponent, {
          key: card.id,
          id: card.id,
          index: index,
          rotate: false,
          animate: true,
          onClick: ($event: any) => (play(card))
        }, null, 8, ["id", "index", "onClick"]))
      }), 128))
    ]),
    _hoisted_3
  ]))
}
}

})